module.exports = __webpack_public_path__ + "img/czzn_032.445d4628.png";